import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';


@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  data: any = {};

  constructor(private servi: ServiceService) { }


  use(lang: string) {
    const langPath = `../../../assets/i18n/${lang || 'es'}.json`;

    this.servi.getResourceLocal(langPath)
    .subscribe( data => { this.data = Object.assign({}, data || {}); });

  }
}
